import {
  axiosAccess,
  axiosDocument,
  axiosFile,
  axiosPayment,
  axiosApplication,
} from "@config/axiosConfig";

export const getCategoryList = async (application_categroy_id: number) => {
  return await axiosAccess.get(
    "/application_category/" + application_categroy_id,
  );
};

export const getAuthorityList = async () => {
  return await axiosAccess.get("/morth_auhtority");
};

export const getTypeOfProperty = async (category_id: number) => {
  return await axiosAccess.get(`/property_type/${category_id}`);
};

export const getLocationList = async () => {
  return await axiosAccess.get(`/location_list`);
};

export const getQuestionsList = async (
  category_id: number,
  location_id: number,
) => {
  return await axiosAccess.get(`/questions/${category_id}/${location_id}`);
};

export const postSubmitAmenities = async (payload: any) => {
  return await axiosAccess.post(`/access_submit`, payload);
};

export const getDocumentsList = async (
  category_id: number,
  access_id: number,
  document: string,
) => {
  return await axiosDocument.get(
    `/${category_id}?application_id=${access_id}&document=${document}`,
  );
};

export const getFileUploadSignedUrl = async (
  fileName: string,
  fileSize: string,
  contentType: string,
  isEsign?: boolean,
) => {
  return await axiosFile.get(
    `/file-upload-signed-url?fileName=${fileName}&moduletype=access&fileSize=${fileSize}&contentType=${contentType}${isEsign ? `&isEsign=${isEsign}` : ""}`,
  );
};

export const getViewFileSignedUrl = async (
  document_name: string,
  folder?: "morth",
) => {
  return await axiosFile.get(
    `/get-file-signed-url?fileName=${document_name}&moduletype=access${
      folder === "morth" ? "&folder=morth" : ""
    }`,
  );
};
export const getViewFileROWSignedUrl = async (
  document_name: string,
  folder?: "morth",
) => {
  return await axiosFile.get(
    `/get-file-signed-url?fileName=${document_name}&moduletype=row${
      folder === "morth" ? "&folder=morth" : ""
    }`,
  );
};
export const getDownloadSignedUrl = async (document_name: string) => {
  return await axiosFile.get(
    `/download-signed-url?fileName=${document_name}&moduletype=access`,
  );
};

export const getDeleteSignedUrl = async (fileName: string) => {
  return await axiosFile.get(
    `/delete-signed-url?fileName=${fileName}&moduletype=access`,
  );
};

export const getSignedUrlList = async () => {
  return await axiosFile.get(`/signed-url-list`);
};

export const postSavedUploadedFile = async (payload: any) => {
  return await axiosDocument.post(`/save-uploaded-file`, payload);
};

export const getUploadedFileById = async (
  access_id: number,
  category_id: number,
  document: string,
) => {
  return await axiosDocument.get(
    `/uploaded-files/${access_id}?module_type=access&application_type_id=${category_id}&document=${document}`,
  );
};

export const deleteFileById = async (
  access_id: number,
  document_id: number,
) => {
  return await axiosDocument.delete(`/delete/${access_id}/${document_id}`);
};

export const submitDocument = async (
  access_id: number,
  category_id: number,
) => {
  return await axiosDocument.get(
    `submit-document/${access_id}?application_type_id=${category_id}&module_type=access&document=file_upload`,
  );
};

// Post BK Pay Body
export const postPayloadBK = async (payload: any) => {
  return await axiosPayment.post(`/generateb64singnedPayment`, payload);
};

export const isPaymentDone = async (payload: any) => {
  return await axiosApplication.post(`/isPaymentDone/${payload}`);
};

// API for consent form step
export const consentFormStep = async (payload: any) => {
  return await axiosDocument.patch(`/consent-form-step`, payload);
};
